import {REPORT_EXPIRING_COACH_RENEWAL} from '/enum/records.enum';

export default {
  reportName: REPORT_EXPIRING_COACH_RENEWAL,
};
